import React from 'react'
import {
  Col, Upload, Select, Radio, Checkbox, Row,
} from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { Query } from 'react-apollo'
import { CUSTOMER_GROUP_LIST, CARGO_TYPE_LIST } from '../../../constants/graphql/query'
import { detailMode } from '../constants'
import { checkInt } from '../../../utils/util-services'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio box
5: Upload box
6: Button
*/

const CreateMode = ({ data, onChangeHandler, mutationVariables }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              onChange: (e) => {
                // if (checkSpecial(e.target.value)) {
                //   e.preventDefault()
                // } else {
                //   onChangeHandler(data.id, e.target.value)
                // }
                onChangeHandler(data.id, e.target.value)
              },
              defaultValue: data.id === 'credit' ? mutationVariables.credit : '',
              onKeyDown: (e) => {
                if (data.id === 'credit' && !checkInt(e)) {
                  e.preventDefault()
                }
              },
              type: data.id === 'credit' ? 'number' : 'text',
              step: data.id === 'credit' ? '1' : undefined,
              min: '0',
            }}
          />
        </Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 4:
      return (
        <Col
          span={data.span}
          style={{
            alignSelf: 'flex-end', margin: '16px 0', display: 'flex', flexDirection: 'column',
          }}
        >
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Radio.Group
            {...data.props}
            options={data.list}
            defaultValue={data.list[0].value}
            onChange={e => onChangeHandler(data.id, data.id === 'typeOfChargeId' ? parseInt(e.target.value, 10) : e.target.value)}
          />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType="picture"
            button={data.props}
          />
        </Col>
      )
    case 6:
      return (
        <Col span={data.span}>
          <UI.P margin='8px 0'>{data.label}</UI.P>
          <Query
            query={CUSTOMER_GROUP_LIST}
            variables={{ limit: 100 }}
          >
            {({ data: customerListData, error, loading }) => {
              if (loading && _.isEmpty(customerListData)) return <UI.Loading center='true' />
              if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              if (_.isUndefined(mutationVariables[data.id])) return <div>{onChangeHandler(data.id, _.find(customerListData.CustomerGroupList.lists, v => v.name === 'ทั่วไป').id)}</div>
              return (
                <Select
                  dropdown
                  defaultValue='ทั่วไป'
                  // showSearch
                  style={{ width: '100%', margin: '8px 0' }}
                  onChange={e => onChangeHandler(data.id, e)}
                >
                  {
                    customerListData.CustomerGroupList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>)
                  }
                </Select>
              )
            }}
          </Query>
        </Col>
      )
    case 7:
      return (
        <Col
          span={data.span}
        >
          <Query
            query={CARGO_TYPE_LIST}
          >
            {({ data: cargoTypeData, error, loading }) => {
              if (loading && _.isEmpty(cargoTypeData)) return <UI.Loading center='true' />
              if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              return (
                <UI.Div display='flex' flexDirection='column' margin='0'>
                  <UI.P margin='8px 0 16px'>{data.label}</UI.P>
                  <Checkbox.Group style={{ width: '100%' }} onChange={e => onChangeHandler(data.id, e)}>
                  <Row>
                  {
                    _.map(cargoTypeData.cargoList, v => (
                      <Col span={4} style={{ margin: '8px 0' }}><Checkbox value={v.id}><UI.P>{v.name}</UI.P></Checkbox></Col>
                    ))
                  }
                  </Row>
                  </Checkbox.Group>
                </UI.Div>
              )
            }}
          </Query>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel
            width='100%'
            {...data.props}
            input={{
              disabled,
              defaultValue: initialData[data.id],
              onChange: e => onChangeHandler(data.id, e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'credit' && !checkInt(e)) {
                  e.preventDefault()
                }
              },
              type: data.id === 'credit' ? 'number' : 'text',
              step: data.id === 'credit' ? '1' : undefined,
              min: '0',
            }}
          />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return (
        <UI.Select
          dropdown
          buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: initialData[data.id] }}
          data={data.children}
          disabled={disabled} {...data.props}
        />
      )
    case 4:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end', margin: '16px 0 0 0' }}
        >
          <Radio.Group
            disabled={disabled}
            {...data.props}
            options={data.list}
            defaultValue={data.id === 'typeOfChargeId' ? initialData.TypeOfCharge.id : initialData[data.id]}
            onChange={e => onChangeHandler(data.id, data.id === 'typeOfChargeId' ? parseInt(e.target.value, 10) : e.target.value)}
          />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            showUploadList={{
              showRemoveIcon: !disabled,
            }}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 6:
      return (
        <Col span={data.span}>
          <UI.P margin='8px 0'>{data.label}</UI.P>
          <Query
            query={CUSTOMER_GROUP_LIST}
            variables={{ limit: 100 }}
          >
            {({ data: customerListData, error, loading }) => {
              if (loading && _.isEmpty(customerListData)) return <UI.Loading center='true' />
              if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              return (
                <Select
                  dropdown
                  disabled={disabled}
                  // showSearch
                  defaultValue={initialData[data.id]}
                  style={{ width: '100%', margin: '8px 0' }}
                  onChange={e => onChangeHandler(data.id, e)}
                >
                  {
                    customerListData.CustomerGroupList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>)
                  }
                </Select>
              )
            }}
          </Query>
        </Col>
      )
    case 7:
      return (
        <Col
          span={data.span}
        >
          <Query
            query={CARGO_TYPE_LIST}
          >
            {({ data: cargoTypeData, error, loading }) => {
              if (loading && _.isEmpty(cargoTypeData)) return <UI.Loading center='true' />
              if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              return (
                <UI.Div display='flex' flexDirection='column' margin='0'>
                  <UI.P margin='8px 0 16px'>{data.label}</UI.P>
                  <Checkbox.Group
                    style={{ width: '100%' }}
                    disabled={disabled}
                    defaultValue={_.map(initialData.cargoType, w => w.id)}
                    onChange={e => onChangeHandler(data.id, e)}
                  >
                  <Row>
                  {
                    _.map(cargoTypeData.cargoList, v => (
                      <Col span={4} style={{ margin: '8px 0' }}><Checkbox value={v.id}><UI.P>{v.name}</UI.P></Checkbox></Col>
                    ))
                  }
                  </Row>
                  </Checkbox.Group>
                </UI.Div>
              )
            }}
          </Query>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} mutationVariables={mutationVariables} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.EDIT:
      return <EditMode data={data} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
